import { cn } from '@lib/cn'
import { FC, PropsWithChildren } from 'react'

type RolexContainerProps = PropsWithChildren<{
  className?: string
  fullWidth?: 'mobile' | 'desktop' | 'all'
  as?: 'div' | 'section'
}>

export const RolexContainer: FC<RolexContainerProps> = ({
  className,
  children,
  fullWidth,
  as = 'section',
}) => {
  const Component = as
  return (
    <Component
      className={cn(
        'container mx-auto w-[100vw] max-w-[86%] md:max-w-[84%]',
        fullWidth === 'mobile' && 'mx-0 max-w-full md:mx-auto',
        fullWidth === 'desktop' && 'md:mx-0 md:max-w-full',
        fullWidth === 'all' && 'w-[100vw] max-w-full md:max-w-full',
        className,
      )}
    >
      {children}
    </Component>
  )
}
